import React from 'react';
import { Formik, Form, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { Box, Button, Container } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import EmailIcon from '@mui/icons-material/Email';
import SendIcon from '@mui/icons-material/Send';
import FormTextField from '@acorn-portal/shared/src/components/inputs/FormTextField';
import { FormikLogErrors } from '@acorn-portal/shared/src/pages/mta/components/FormikLogErrors';

export interface IEmailRegistrationForm {
	onSubmit: (email: string) => void;
}

interface FormValues {
	email: string;
}

const initialValues: FormValues = {
	email: '',
};

const validationSchema = Yup.object({
	email: Yup.string().email('Please enter a valid email address').required('Email field is required.'),
});

const EmailRegistrationForm: React.FC<IEmailRegistrationForm> = ({ onSubmit }) => {
	const handleSubmit = (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
		onSubmit(values.email);
		setSubmitting(false);
	};

	return (
		<Container sx={{ pb: 3 }}>
			<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
				{({ isSubmitting, handleChange, touched, errors, values }) => (
					<Form>
						<FormikLogErrors />
						<FormTextField
							id='email'
							name='email'
							label='Email'
							format='email'
							autoComplete='email'
							error={touched.email && Boolean(errors.email)}
							helperText={touched.email && errors.email}
							onChange={handleChange}
							value={values.email}
							InputProps={{
								startAdornment: (
									<InputAdornment position='start'>
										<EmailIcon />
									</InputAdornment>
								),
							}}
						/>

						<Box display='flex' justifyContent='center'>
							<Button
								type='submit'
								variant='contained'
								color='primary'
								disabled={isSubmitting}
								startIcon={<SendIcon />}
								sx={{
									maxWidth: { sm: 400, md: 300 },
									width: '100%',
								}}
							>
								Send Email
							</Button>
						</Box>
					</Form>
				)}
			</Formik>
		</Container>
	);
};

export default EmailRegistrationForm;
